
import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import About from "../pages/about/page";
import Services from "../pages/services/page";
import Blog from "../pages/blog/page";
import Contact from "../pages/contact/page";
import BelgelendirmeHizmetleri from "../pages/services/belgelendirme/page";
import YonetimSistemleri from "../pages/services/yonetim-sistemleri/page";
import TeknikKontroller from "../pages/services/teknik-kontroller/page";
import DenetimGozetim from "../pages/services/denetim-gozetim/page";
import EnerjiVerimliligi from "../pages/services/enerji-verimliligi/page";
import OzelDenetimler from "../pages/services/ozel-denetimler/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/about",
    element: <About />,
  },
  {
    path: "/services",
    element: <Services />,
  },
  {
    path: "/services/belgelendirme",
    element: <BelgelendirmeHizmetleri />,
  },
  {
    path: "/services/yonetim-sistemleri",
    element: <YonetimSistemleri />,
  },
  {
    path: "/services/teknik-kontroller",
    element: <TeknikKontroller />,
  },
  {
    path: "/services/denetim-gozetim",
    element: <DenetimGozetim />,
  },
  {
    path: "/services/enerji-verimliligi",
    element: <EnerjiVerimliligi />,
  },
  {
    path: "/services/ozel-denetimler",
    element: <OzelDenetimler />,
  },
  {
    path: "/blog",
    element: <Blog />,
  },
  {
    path: "/contact",
    element: <Contact />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;
